/**
 * En-tête : ouverture du menu sur les petits écrans.
 * Le panneau se referme après un clic sur un lien et à l'élargissement de la
 * fenêtre, pour ne pas rester ouvert en affichage bureau.
 */
(() => {
  const burger = document.querySelector('[data-oyw-header-burger]');
  const nav = document.getElementById('oyw-header-nav');
  if (!burger || !nav) return;

  const fermer = () => {
    nav.removeAttribute('data-ouvert');
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label', 'Ouvrir le menu');
  };

  burger.addEventListener('click', () => {
    const ouvert = burger.getAttribute('aria-expanded') === 'true';
    if (ouvert) {
      fermer();
    } else {
      nav.setAttribute('data-ouvert', '');
      burger.setAttribute('aria-expanded', 'true');
      burger.setAttribute('aria-label', 'Fermer le menu');
    }
  });

  nav.addEventListener('click', (evenement) => {
    if (evenement.target.closest('a')) fermer();
  });

  window.matchMedia('(min-width: 1081px)').addEventListener('change', (evenement) => {
    if (evenement.matches) fermer();
  });
})();
